const trimTrailingSlash = (value) => (value || '').replace(/\/+$/, '');

export const PUBLIC_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_PUBLIC_BASE_URL || 'https://www.oengines.com'
);

export const CONTACT_URL = '/contactus';
export const CAREERS_URL = '/careers';
export const RESUME_UPLOAD_URL = '/resumeUpload';
export const BLOG_CATEGORIES_URL = '/blogsCategories';
export const EMPLOYEE_POSTS_URL = '/employee-posts';
export const TERMS_PRIVACY_URL = '/terms-privacy-html-contents';
export const HEADERS_URL = '/headers';

export const gameDetailsUrl = (keyword) =>
  `/games?filter[where][keyword]=${encodeURIComponent(keyword || '')}`;

export const gameCategoryUrl = (category) =>
  `/games?filter[limit]=5&filter[where][is_deleted]=false&filter[where][is_active]=true&filter[where][category]=${encodeURIComponent(category || '')}`;
